let youtubeScriptLoaded = false;

function loadYouTubeIframePlayerApi() {
	if (youtubeScriptLoaded) {
		return;
	}

	const tag = document.createElement('script');
	const firstScriptTag = document.getElementsByTagName('script')[0];

	tag.src = 'https://www.youtube.com/iframe_api';
	firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
	youtubeScriptLoaded = true;
}

export default class CampagnesModule {
	constructor(el) {
		this.el = el;
		this.buttons = this.el.querySelectorAll('[data-campagne-button]');
		this.items = this.el.querySelectorAll('[data-campagne-item]');

		window.onYouTubeIframeAPIReady = () => {
			this.videos = Array.from(this.el.querySelectorAll('[data-campagne-yt]')).map((div) => {
				return new YouTubeVideo(div);
			});
		};

		loadYouTubeIframePlayerApi();

		this.el.addEventListener('click', (e) => {
			if (!e.target) {
				return;
			}

			const button = e.target.closest('[data-campagne-button]');

			if (!button) {
				return;
			}

			this.activateItem(button.dataset.campagneButton);
		});
	}

	activateItem(id) {
		this.buttons.forEach((button) => {
			if (button.dataset.campagneButton == id) {
				button.classList.add('active');
			} else {
				button.classList.remove('active');
			}
		});

		this.items.forEach((item) => {
			if (item.dataset.campagneItem == id) {
				item.classList.add('active');
			} else {
				item.classList.remove('active');
			}
		});

		this.videos.forEach((video) => {
			video.pause();
		});
	}
}

class YouTubeVideo {
	constructor(el) {
		this.el = el;
		this.playerEl = this.el.querySelector('[data-campagne-yt-player]');
		this.overlay = this.el.querySelector('[data-campagne-yt-overlay]');
		this.hasPlayed = false;

		if (!this.playerEl) {
			return;
		}

		this.el.addEventListener('click', (e) => {
			if (!e.target) {
				return;
			}

			const button = e.target.closest('[data-campagne-yt-button]');

			if (!button) {
				return;
			}

			this.loadVideo();
			this.removeOverlay();
		});
	}

	loadVideo() {
		const data = JSON.parse(this.el.dataset.campagneYt);

		if (!this.player) {
			this.createplayer({
				videoId: data.id,
			});
		}
	}

	createplayer(options) {
		this.player = new YT.Player(this.playerEl, {
			playerVars: {
				modestbranding: 1,
				playsinline: 1,
				rel: 0,
				enablejsapi: 1,
				showinfo: 0,
				autoplay: 1,
			},
			...options,
		});
	}

	removeOverlay() {
		if (!this.hasPlayed) {
			this.overlay.remove();
			this.hasPlayed = true;
		}
	}

	pause() {
		if (this.player) {
			this.player.pauseVideo();
		}
	}
}
